import { AbstractControl, ValidationErrors } from '@angular/forms';
import { PersonService } from './person.service';
import { map, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./person.service";
var PersonEmailExists = /** @class */ (function () {
    function PersonEmailExists(personSvc) {
        this.personSvc = personSvc;
    }
    PersonEmailExists.prototype.validate = function (ctrl) {
        return this.personSvc.findByEmail(ctrl.value).pipe(map(function (res) {
            return (res.data[0].emailExists ? { emailExists: true } : null);
        }), catchError(function () { return null; }));
    };
    PersonEmailExists.ngInjectableDef = i0.defineInjectable({ factory: function PersonEmailExists_Factory() { return new PersonEmailExists(i0.inject(i1.PersonService)); }, token: PersonEmailExists, providedIn: "root" });
    return PersonEmailExists;
}());
export { PersonEmailExists };
var PersonEmailExistsDirective = /** @class */ (function () {
    function PersonEmailExistsDirective(validator) {
        this.validator = validator;
    }
    PersonEmailExistsDirective.prototype.validate = function (control) {
        return this.validator.validate(control);
    };
    return PersonEmailExistsDirective;
}());
export { PersonEmailExistsDirective };
